import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import stl from "./UnbxdTitleArea.module.css";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { getSearchPageH1Title, isAutosOrYearsScreen, isFiltersScreen } from "@/pages/search/searchHooks/filtersHelpers";
import { useLocation } from "react-router-dom";
import UnbxdBreadCrumb from "@/components/SearchComponent/UnbxdComponents/UnbxdBreadCrumb";
import useIsMobile from "@hooks/useIsMobile";
import loadable from "@loadable/component";
import ToggleCarCompare from "@/_MiniApps/CarCompare/Components/ToggleCarCompare";
import useFilterPage, { useSearchResultsData } from "@/pages/search/searchHooks/useSearchAndFilters";
import Container from "@/components/sharedComponents/container/Container";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
var fallback = {
  fallback: null
};
var UnbxdSort = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "UnbxdSort-UnbxdSort";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "UnbxdSort-UnbxdSort" */"../UnbxdSort/UnbxdSort");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../UnbxdSort/UnbxdSort");
    }
    return eval('require.resolve')("../UnbxdSort/UnbxdSort");
  }
}, fallback);
var UnbxdTitleArea = function UnbxdTitleArea(_ref) {
  var _searchResultsData$po;
  var _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isMobile = useIsMobile();
  var location = useLocation();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useFilterPage = useFilterPage(),
    sort = _useFilterPage.sort,
    dealId = _useFilterPage.dealId,
    searchTerm = _useFilterPage.searchTerm;
  var searchResultsData = useSearchResultsData();
  var hasResults = (searchResultsData === null || searchResultsData === void 0 ? void 0 : (_searchResultsData$po = searchResultsData.posts) === null || _searchResultsData$po === void 0 ? void 0 : _searchResultsData$po.length) > 0;
  var _getSearchPageH1Title = getSearchPageH1Title({
      searchResults: searchResultsData,
      searchTerm: searchTerm,
      t: t
    }),
    h1Title = _getSearchPageH1Title.title,
    resultsCount = _getSearchPageH1Title.count,
    titleAbbreviation = _getSearchPageH1Title.titleAbbreviation;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    id: "posts-title-area",
    className: stl.wrapper
  }, !loading && isAutosOrYearsScreen(location) && /*#__PURE__*/React.createElement(UnbxdBreadCrumb, null), !isNaN(dealId) && /*#__PURE__*/React.createElement("button", {
    id: "posts-title-remove-deal-btn",
    className: stl.removeDealBtn,
    onClick: function onClick() {
      navigateTo("/filters");
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "close",
    src: CDN_LINK + "/assets/images/closedealNow.svg"
  }), t("عروض سيارات", {
    ns: "web_search"
  })), !loading && isNaN(dealId) && /*#__PURE__*/React.createElement("div", {
    id: "posts-title-h1-area",
    className: stl.h1Area
  }, /*#__PURE__*/React.createElement("h1", {
    id: "posts-title-h1"
  }, h1Title), " ", hasResults && /*#__PURE__*/React.createElement(React.Fragment, null, "- ", /*#__PURE__*/React.createElement("span", null, resultsCount)), isFiltersScreen(location) && /*#__PURE__*/React.createElement("span", null, titleAbbreviation)), loading && isAutosOrYearsScreen(location) && /*#__PURE__*/React.createElement("div", {
    className: stl.h1Area
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    className: "mt-1",
    divHeight: isMobile ? 40 : 40,
    divWidth: 199
  })), !isMobile && /*#__PURE__*/React.createElement("div", {
    id: "posts-title-desktop-controls",
    className: "flex gap-6 items-center mt-2"
  }, !loading && /*#__PURE__*/React.createElement(ToggleCarCompare, null), !loading && hasResults && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(UnbxdSort, {
    sort: sort,
    selectedOptions: searchResultsData === null || searchResultsData === void 0 ? void 0 : searchResultsData.selectedOptions,
    sortOptions: searchResultsData === null || searchResultsData === void 0 ? void 0 : searchResultsData.sortOptions
  }))))));
};
export default UnbxdTitleArea;